export const styles = theme => ({
  mainContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 15,
      paddingRight: 15,
      marginTop: 20
    },
    [theme.breakpoints.up('xs')]: {
      marginTop: 20,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up(500)]: {
      marginTop: 40,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
      paddingLeft: 12,
      paddingRight: 12
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 40,
      paddingLeft: 33,
      paddingRight: 33
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 40,
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  containerCard: {
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center'
    }
  },
  addBtn: {
    padding: '3rem 0',
    textTransform: 'uppercase'
  },
  btn: {
    marginRight: '1rem'
  }
});
